export default function compoundSurveyRoutes() {
  this.route("compound-surveys", function () {
    this.route("edit", function () {
      this.route("survey-completed", {
        path: "/:je_id"
      });
    });
    this.route("new", {
      path: "/:survey_id"
    });
    this.route("results");
  });
}